
import { MY_ENDPOINTS } from "@raashidh/shared";
import { ORDER_STATUSES } from "@raashidh/shared";
import { myMutation } from "../../hooks/myMutation";
import OrderCardUser from "../admin/OrderCardUser";
import MyTableList from "../../MY_COMPONENTS/MyTableList";

export default function MyOrders() {

  const updateOrder = myMutation<{
      order_id: number;
      [key: string]: any;
    }>({
    endpoint: "",
    method: "PUT",
    invalidateKeys: [["allorders"]],
  })
  
  const deleteOrder = myMutation<{
      order_id: number;
      [key: string]: any;
    }>({
    endpoint: "",
    method: "PUT",
    invalidateKeys: [["allorders"]],
  })

  return (
     <MyTableList
        endpoint={MY_ENDPOINTS.ORDER_APIS.LIST_MY.path}
        queryKey="userorders"
        pageLabel="My Orders"
        statuses={ORDER_STATUSES}
        idKey="order_id"
        columnsList={[
          "order_id",
          "order_status",
          "order_customer_name",
          "order_delivery_confirmed",
        ]}
        columnLabels={{
          order_id: "ID",
          order_status: "Status",
          order_customer_name: "Customer",
          order_delivery_confirmed: "Delivered?",
        }}
        switchColumns={["order_delivery_confirmed"]}
        onToggle={(row, col) =>
          updateOrder.mutate({ order_id: row.order_id, [col]: !row[col] })
        }
        onDelete={(row) => deleteOrder.mutate(row.order_id)}
        getDeleteLabel={(row) => String(row.order_id)}
        viewDialog={(row) => <OrderCardUser order={row} />}
      />
  );
}

